<template>
  <div class="bigscreen_policyNews_container">
    <div class="image_slider">
      <el-carousel
        style="width:100%;height:90%;"
        indicator-position="none"
        :interval="5000"
      >
        <el-carousel-item
          v-for="(item,index) in imgList"
          :key="'slider_image_'+index"
        >
          <el-image
            style="width: 80%; height: 100%;padding-left:10%;"
            :fit="'contain'"
            @click="toPolicyItem(item)"
            :src="item.converImgUrl"
          >
          </el-image>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="news_container">
      <div class="tab_container">
        <div class="tab_list">
          <div
            class="tab_item"
            :class="activeTab==item.dicNumber?'active':''"
            v-for="item in typeList"
            :key="item.dicNumber"
            @click="tabClickHander(item)"
          >{{item.dicName}}</div>
        </div>
        <div class="link_more" @click="toPolicy">更多
          <img
            src="../../../../static/img/titleArrowImg.png"
            width="10px"
            style="vertical-align: middle;margin-top: -1px;"
            alt=""
          >
        </div>
      </div>
      <div class="data_container">
        <div
          class="item"
          @click="toPolicyItem(item)"
          v-for="item in dataList"
        >
          <div
            class="title"
            v-if="item.titile.length<=25"
          >{{item.titile}}</div>
          <el-tooltip
            v-else
            :content="item.titile"
            placement="top"
            :open-delay='300'
          >
            <div class="title">{{item.titile}}</div>
          </el-tooltip>
          <div class="date">{{item.date}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie"
import API from "@/api/bigScreen/api_big_screen";
export default {
  data() {
    return {
      imgList: [],
      typeList: [
        {
          dicNumber: '10611001',
          dicName: "政策法规",
        },
        {
          dicNumber: '10611002',
          dicName: "时事要闻",
        },
        {
          dicNumber: '10611003',
          dicName: "通知公告",
        },
      ],
      dataList: [],
      activeTab: '10611001',
      activeTabName: '政策法规',
      areaCode: Cookies.get('curAreaCode')
    }
  },
  created() {
    this.getData();
  },
  methods: {
    toPolicyItem(item){
      let path = "/policy/article"
      this.$router.push({
        path: path,
        query: {
          id: item.number,
          title: this.activeTabName,
          tabId: this.activeTab
        },
      });
    },

    toPolicy(){
      this.$router.push({ path: "/policy/policyList" })
    },

    tabClickHander(item) {
      this.activeTab = item.dicNumber;
      this.activeTabName = item.dicName
      this.getData();
    },

    async getData() {
      let params = {
        typeDicNumber: this.activeTab,
        qhdm: this.areaCode
      };
      let { code, data } = await API.policyNews(params);
      if (code == 0) {
        data.list.forEach((item) => {
          item.date = this.intToDate(item.pulishTime);
        });
        this.dataList = data.list;
        this.imgList = data.imgList.filter(item =>item.converImgUrl);
      }
    },

    intToDate(number) {
      let str = "--";
      if (number) {
        let dateStr = number + "";
        let year = dateStr.substring(0, 4);
        let month = dateStr.substring(4, 6);
        let day = dateStr.substring(6);
        str = year + "-" + month + "-" + day;
      }
      return str;
    },
  }
};
</script>
<style lang="less">
  .bigscreen_policyNews_container {
    width: 100%;
    height: calc(100% - 40px);
    display: flex;
    padding-bottom: 30px;
    box-sizing: border-box;
    .image_slider {
      width: 320px;
      height: 98%;
      padding-top: 2%;
      .el-carousel__container {
        height: 100% !important;
        .el-carousel__arrow{
          background-repeat: no-repeat;
          background-size: 150%;
          background-position: center;
          >i{
            &::before{
              content: '';
            }
          }
        }
        .el-carousel__arrow--left{
          background-image: url('../../../../static/img/prev.png');
          left: 2px;
        }
        .el-carousel__arrow--right{
          background-image: url('../../../../static/img/next.png');
          right: 2px;
        }
      }
    }
    .news_container {
      width: calc(100% - 300px);
      height: 100%;
      .tab_container {
        display: flex;
        height: 40px;
        padding: 4px;
        box-sizing: border-box;
        .link_more {
          width: 50px;
          line-height: 32px;
          height: 100%;
          cursor: pointer;
          &:hover{
            color: #aaffff;
          }
        }
        .tab_list {
          flex: 1;
          height: 100%;
          overflow-x: auto;
          overflow-y: hidden;
          .tab_item {
            display: inline-block;
            margin-right: 4px;
            width: 100px;
            height: 32px;
            line-height: 30px;
            text-align: center;
            border: 1px solid #00ffff;
            font-size: 16px;
            font-weight: bold;
            cursor: pointer;
            box-sizing: border-box;
            &.active,
            &:hover {
              color: #00ffff;
            }
          }
        }
      }
      .data_container {
        height: calc(100% - 40px);
        width: 100%;
        overflow-y: auto;
        padding: 8px;
        box-sizing: border-box;
        background-image: url("../../../../static/img/containerBackImg.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        .item {
          width: 100%;
          height: 40px;
          // display: flex;
          line-height: 40px;
          cursor: pointer;
          font-size: 0;
          // &:hover{
          //   color: #ccffff;
          // }
          .title,
          .date {
            display: inline-block;
            height: 100%;
            vertical-align: middle;
            font-size: 14px;
          }
          .title {
            width: calc(100% - 90px);
            //超出一行省略号
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            padding: 0 4px;
            font-weight: bold;
            box-sizing: border-box;
          }
          .date {
            display: inline-block;
            width: 90px;
            text-align: center;
          }
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/studio/homepage/home/homecenterbottom.vue